module.exports = __webpack_public_path__ + "img/outer-6.520519cd.png";